import { DateString } from "../../server/src/DateString";
import { EdiPOItem } from "../../server/src/edi/EdiPOItem";
import { IEdiPO } from "../../server/src/edi/IEdiPO";
import { IEdiPOItem } from "../../server/src/edi/IEdiPOItem";


export function preparePO(po: IEdiPO, kontrahent_idn: string) {

    if (!po) return undefined;
   
    po.MSG_type="PO"
    const file_id = ('00000000000'+po['PO_id_customer']).slice(-11)
    po.MSG_file_name='grafpol_po_'+kontrahent_idn+'_'+file_id+".json"
    const anypo:any = { ...po }; // Create a shallow copy of the po
    anypo.MSG_export_date=DateString.toISOString()
    anypo.items=[]
    for (let j=0;j<po.items.length;j++) {
      (anypo.items[j])  = preparePOItem(po, po.items[j], kontrahent_idn, j)
    }
    return anypo;
}


export function preparePOItem( po: IEdiPO, item: IEdiPOItem, kontrahent_idn:string, pos:number): EdiPOItem {

    console.log("preparing item:",pos, item)
    const it:IEdiPOItem = { ...item }; // Create a shallow copy of the item

    delete (<any>it).wytwor_id
    
    if (kontrahent_idn.toUpperCase().indexOf('RAFLATAC')>-1) {
      it['ITEM_material_code_supplier'] = '641578' + it['ITEM_material_code_supplier'].trim();
      it['ITEM_material_code_supplier'] = it['ITEM_material_code_supplier'].replace('641578641578',"641578")

      if (!validateEAN13(it['ITEM_material_code_supplier'])) throw new Error("Nieprawidłowy kod EAN13: "+it['ITEM_material_code_supplier']+" Zamówienie "+po.PO_code_customer+" Pozycja "+it.ITEM_pos_number)
    } else if (kontrahent_idn=='AVERY') {
      it['ITEM_material_code_supplier'] =  it['ITEM_material_code_supplier'].trim();
      if (!it['ITEM_material_code_supplier']) throw new Error("Brak kodu materiału."+"Zamówienie "+po.PO_code_customer+" Pozycja "+it.ITEM_pos_number)
    }

    

    let length = 0;

    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('1000') > -1) length = 1000;
    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('2000') > -1) length = 2000;
    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('3000') > -1) length = 3000;
    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('4000') > -1) length = 4000;

    if (!length) it['ITEM_remarks'] = po['PO_remarks'];

    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('1000') > -1) length = 1000;
    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('2000') > -1) length = 2000;
    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('3000') > -1) length = 3000;
    if (it['ITEM_remarks'] && it['ITEM_remarks'].indexOf('4000') > -1) length = 4000;
    it.ITEM_reel_length_m = length;
    if (!it.ITEM_reel_length_m) throw new Error("Nie można ustalić długości roli z uwag. "+"Zamówienie "+po.PO_code_customer+" Pozycja "+it.ITEM_pos_number)

    
    it.ITEM_reel_width_mm = 0;
    if (it['ITEM_material_name_customer']) {
      let width = 0;
      const str_width = it['ITEM_material_name_customer'].trim().slice(-3);
      if (str_width) {
        width = parseInt(str_width);
        if (width > 50 && width < 1000) it.ITEM_reel_width_mm = width;
      }
    }
    if (!it.ITEM_reel_width_mm) throw new Error("Nie można ustalić szerokości roli z nazwy surowca "+it['ITEM_material_name_customer']+" Zamówienie "+po.PO_code_customer+" Pozycja "+it.ITEM_pos_number)

    if (!it['ITEM_amount']) throw new Error("Nie jest podana ilość "+" Zamówienie "+po.PO_code_customer+" Pozycja "+it.ITEM_pos_number)

    it.ITEM_reel_count = 0;
    if (it['ITEM_amount'] && it.ITEM_reel_width_mm && it.ITEM_reel_length_m) {
      let reels = 0;
      reels = it['ITEM_amount'] / ((it.ITEM_reel_width_mm/1000) * it.ITEM_reel_length_m);
      reels = Math.ceil(reels);
      it.ITEM_reel_count = reels;
    }
    if (!it.ITEM_reel_count) throw new Error("Nie można ustalić ilości rolek "+it['ITEM_material_name_customer']+" Zamówienie "+po.PO_code_customer+" Pozycja "+it.ITEM_pos_number)


    it['ITEM_delivery_date'] = po['PO_delivery_date'];
    
    console.log("EdiPOItem.prepare",it)
    return it;
  }
  
  function validateEAN13(ean:any) {

    if (!ean) return false;
    // Ensure the EAN code is exactly 13 digits
    if (!/^\d{13}$/.test(ean)) {
      return false;
    }

    // Separate the check digit (last digit)
    const checkDigit = parseInt(ean[12], 10);

    // Calculate the check digit based on the first 12 digits
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      const digit = parseInt(ean[i], 10);
      sum += i % 2 === 0 ? digit : digit * 3;
    }

    // Calculate the required check digit
    const calculatedCheckDigit = (10 - (sum % 10)) % 10;

    // Compare calculated check digit with the provided check digit
    return calculatedCheckDigit === checkDigit;
  }